import React from 'react';
import CharacterCard from './CharacterCard';

function CharacterGrid({ characters }) {
  return (
    <div className="character-grid">
      {characters.map(char => (
        <CharacterCard key={char.id} character={char} />
      ))}
    </div>
  );
}

export default CharacterGrid;
